import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { BFXNotificationType } from "../../../shared/cubiq-services/model/core/notifications/BFXNotificationType";
import { v4 as uuid } from "uuid";

export class BfxPopupEventSetting {
  public type: BFXNotificationType;
  public blotterType: CubiqTS.BlotterType;
  public eventIdentifier: string = "";
  public enabled: boolean = false;
  public audio: any = null;
  public disableAllAudio: boolean = false;
  public filter: { name: string; id: string; blotterType: number } = null;
  public filterList: Array<any> = [];
  public returnOnLogin: boolean = null;
  public isBmark: boolean = false;

  constructor(
    type: BFXNotificationType,
    eventIdentifier: string,
    enabled: boolean,
    audio: any,
    disableAllAudio: boolean,
    filter: any,
    blotterType: CubiqTS.BlotterType,
    isBmark: boolean = false,
  ) {
    this.type = type;
    this.eventIdentifier = eventIdentifier;
    this.enabled = enabled;
    this.audio = audio;
    this.disableAllAudio = disableAllAudio;
    this.filter = filter;
    this.blotterType = blotterType;
    this.isBmark = typeof isBmark === "boolean" ? isBmark : false;
  }
}
